
import * as definitions from 'store/definitions/certificates'

export function fetchAll() {
  return {
    type: definitions.FETCH_ALL_CERTIFICATES,
  };
}
